import React from 'react';
import TagLinkGroup from '@core-ui/tag-link-group';
import propTypes from './types';

const RelatedCategories = ({customLabel, categories, onCategoryClick}) => {

  const hasCategories = categories.length > 0

  return hasCategories ? (
    <div className="related-categories">
      <TagLinkGroup
        className="tag-link-group"
        heading={customLabel}
        links={categories}
        onTagClick={onCategoryClick} />
    </div>
  ) : null;

}

RelatedCategories.propTypes = propTypes;

export default RelatedCategories;
